import { render, staticRenderFns } from "./studentsList.vue?vue&type=template&id=72f68a0c&scoped=true"
import script from "./studentsList.vue?vue&type=script&lang=js"
export * from "./studentsList.vue?vue&type=script&lang=js"
import style0 from "./studentsList.vue?vue&type=style&index=0&id=72f68a0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f68a0c",
  null
  
)

export default component.exports